import Remediation from '@/models/Remediation.js';

export default {
    computed: {
        remediations() {
            const activityId =
                this.activity?.id || this.activity_id || this.activityId || this.$route.params.activityId;

            const query = Remediation.query().where('activity_id', activityId);

            query.where('user_id', this.authUser.id);

            return query.get();
        },
    },
};
